export default {
  path: '/other',
  component: () => import('../components/Index'),
  children: [
    {
      path: "player",
      meta: {
        hideHeader: true,
        hideFotter: true,
      },
      component: () => import('../components/other/Player'),
    },
     {
      path: "authorization",
      meta: {
        hideHeader: true,
        hideFotter: true,
      },
      component: () => import('../components/other/Authorization'),
    },
  ],
}



// WEBPACK FOOTER //
// ./src/pages/pc/router/other.js